function normalize(url: string) {
  return url.replace(/\/$/, "");
}

function isAllowedTrakEndpoint(url: URL) {
  return url.protocol === "https:" && (url.hostname === "trak.codes" || url.hostname.endsWith(".trak.codes"));
}

function isAllowedLocalEndpoint(url: URL) {
  return import.meta.env.DEV && (url.hostname === "localhost" || url.hostname === "127.0.0.1");
}

function readAllowedQueryEndpoint(name: string) {
  try {
    const value = new URL(window.location.href).searchParams.get(name);
    if (!value) return null;
    const url = new URL(value);
    if (isAllowedTrakEndpoint(url) || isAllowedLocalEndpoint(url)) return normalize(url.toString());
  } catch (_) {}

  return null;
}

export const dbBaseUrl = normalize(
  readAllowedQueryEndpoint("dbEndpoint") ?? import.meta.env.VITE_DB_ENDPOINT ?? "https://api.trak.codes/v0"
);

export const backendBaseUrl = normalize(import.meta.env.VITE_BACKEND_ENDPOINT ?? "https://backend.trak.codes/api/v0");